import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/terms-categories/profile/loading';

export const Route = createFileRoute('/_private/settings/terms-categories/$id')({
  pendingComponent: Loading,
});
